module.exports = __webpack_public_path__ + "static/media/heading-43021-2-M.a3e0be10.jpg";